import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  signal,
  WritableSignal,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[rpEmptyToNull]',
  standalone: true,
  host: {
    '(focusout)': 'onBlur()',
  },
})
export class EmptyToNullDirective implements AfterViewInit {
  private _el = inject(ElementRef);
  private _ngControl = inject(NgControl, { self: true, optional: true });

  private _inputNgControl: WritableSignal<NgControl | null> = signal(this._ngControl);

  ngAfterViewInit(): void {
    if (!this._ngControl) {
      const inputElement = this._el.nativeElement.querySelector('input');
      if (inputElement) {
        this._inputNgControl.set(inputElement.__ngControl__ || null);
      }
    }
  }

  onBlur(): void {
    const control = this._inputNgControl();
    if (control?.control?.value === '') {
      control.control.setValue(null, { emitEvent: false });
    }
  }
}
